module.exports = __webpack_public_path__ + "img/鄙视.4fd26b59.png";